import { render, staticRenderFns } from "./ModalCreateCustomer.vue?vue&type=template&id=79bb6e96&scoped=true"
import script from "./ModalCreateCustomer.vue?vue&type=script&lang=js"
export * from "./ModalCreateCustomer.vue?vue&type=script&lang=js"
import style0 from "./ModalCreateCustomer.vue?vue&type=style&index=0&id=79bb6e96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79bb6e96",
  null
  
)

export default component.exports